import React from "react";
import AnimateNav from "../components/Home/AnimateNav";
import HeroSetion from "../components/Home/HeroSetion";
import OurCourses from "../components/Home/OurCourses";
import Testimonials from "../components/Home/Testimonials";
import Footer from "../components/Home/Footer";
import Navbar from "../components/Home/Navbar";

const companies = [
  {
    id: 1,
    img: "./images/tower.png",
  },
  {
    id: 2,
    img: "./images/realty.png",
  },
  {
    id: 3,
    img: "./images/prologis.png",
  },
  {
    id: 4,
    img: "./images/equinix.png",
  },
];

const Home = () => {
  return (
    <div>
      <Navbar />
      <AnimateNav />
      <HeroSetion companies={companies} />
      <OurCourses />
      <Testimonials />
      <Footer />
    </div>
  );
};

export default Home;
